const header = document.querySelector('.header');
window.addEventListener('load', () => {
  if (window.pageYOffset > 0) {
    header.classList.add('header_fixed');
  }
});
window.addEventListener('scroll', () => {
  if (window.pageYOffset > 0 && !header.classList.contains('header_fixed')) {
    header.classList.add('header_fixed');
  }
  else if (window.pageYOffset === 0 && header.classList.contains('header_fixed')) {
    header.classList.remove('header_fixed');
  }
});

window.addEventListener('load', () => {
  const showPopup = (target) => {
    target.classList.add('popup_visible');
  }
  const closePopups = () => {
    [...document.querySelectorAll('.popup_visible')].map(popup => {
      popup.classList.remove('popup_visible')
    })
  }
  const popupCloseBtns = document.querySelectorAll('.popup__close');
  [...popupCloseBtns].map(close => {
    close.addEventListener('click', (e) => {
      e.preventDefault();
      closePopups();
      const videos = document.querySelectorAll('.popup_video video');
      if (videos.length) {
        [...videos].map(video => {
          video.remove();
        })
      }
    })
  })
  const popupLinks = document.querySelectorAll('.js-popup-link');
  if (popupLinks.length) {
    [...popupLinks].map(link => {
      link.addEventListener('click', (e) => {
        e.preventDefault();
        const targetElement = document.querySelector(link.getAttribute('href'));
        if (targetElement.classList.contains('popup_video')) {
          if (!targetElement.querySelector('.popup__body').childNodes.length) {
            const aboutVideo = document.createElement('video');
            aboutVideo.classList.add('video-js');
            aboutVideo.setAttribute('controls', 'true');
            aboutVideo.setAttribute('preload', 'auto');
            aboutVideo.setAttribute('poster', 'img/video-poster.jpg');
            aboutVideo.setAttribute('data-setup', '{}');
            const mp4Source = document.createElement('source');
            mp4Source.setAttribute('src', 'about.mp4');
            mp4Source.setAttribute('type', 'video/mp4');
            const webmSource = document.createElement('source');
            webmSource.setAttribute('src', 'about.webm');
            webmSource.setAttribute('type', 'video/webm');
            aboutVideo.prepend(mp4Source);
            aboutVideo.prepend(webmSource);
            targetElement.querySelector('.popup__body').prepend(aboutVideo);
          }
        }
        showPopup(targetElement);
      })
    })
  }
});

window.addEventListener('load', () => {
  const blockPain = document.querySelector('.block_pain');
  if (blockPain) {
    const title = blockPain.querySelector('h2');
    const li = blockPain.querySelector('.list_pain li:nth-child(3)');
    li.append(title);
  }
});

window.addEventListener('load', () => {
  const title = document.querySelector('.block_useful .title');
  if (title) {
    title.innerHTML = '<span>Почему я</span><span>уверен, что</span><span>могу дать</span><span>полезность?</span>'
    title.classList.remove('nojs');
  }
})

window.addEventListener('load', () => {
  const burgerButton = document.querySelector('#header__burger');
  if (burgerButton) {
    const burgerMenu = document.getElementById('burger-menu');
    const closeBurger = () => {
      burgerMenu.classList.remove('burger-menu_visible');
    }
    const closeButton = burgerMenu.querySelector('.burger-menu__close');
    const links = burgerMenu.querySelectorAll('nav a');
    burgerButton.addEventListener('click', (e) => {
      e.preventDefault();
      burgerMenu.classList.add('burger-menu_visible');
    })

    closeButton.addEventListener('click', (e) => {
      e.preventDefault();
      closeBurger();
    });

    [...links].map(link => {
      link.addEventListener('click', () => {
        closeBurger();
      })
    })
  }
})
